import(/* webpackMode: "eager", webpackExports: ["SimulateErrorControls"] */ "/vercel/path0/src/app/components/ErrorHandling/SimulateErrorControls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["consentClient","getConsent"] */ "/vercel/path0/src/browser-lib/cookie-consent/consentClient.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppComponents/LayoutSiteFooter/LayoutSiteFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AppComponents/TopNav/TopNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeacherBrowseAnalyticsStoreProvider"] */ "/vercel/path0/src/context/TeacherBrowseAnalytics/TeacherBrowseAnalyticsProvider.tsx");
